import { render, staticRenderFns } from "./Preview-File.vue?vue&type=template&id=8807fdba"
import script from "./Preview-File.vue?vue&type=script&lang=js"
export * from "./Preview-File.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports